import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { services } from '../../mockData';
import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';

const ServicesOverview = () => {
  // Feature 6 key services for homepage
  const featuredServices = services.slice(0, 6);

  return (
    <section className="relative py-24 bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage:
          "url('https://images.unsplash.com/photo-1656231975739-2dee9836dc54?q=80&w=762&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
      }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 text-white ">
            Our Services
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-white">
            Delivering domain expertise and technology-driven offerings to help you turn digital challenges into opportunities
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredServices.map((service) => {
            const IconComponent = Icons[service.icon] || Icons.Code;
            return (
              <Link
                key={service.id}
                to={`/services/${service.slug}`}
                className="group bg-gradient-to-br from-gray-50 to-white rounded-2xl p-8 border border-gray-200 hover:border-indigo-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <IconComponent className="w-7 h-7 text-white" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-indigo-600 transition-colors duration-200">
                  {service.name}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{service.shortDescription}</p>
                <div className="flex items-center text-indigo-600 font-medium text-sm group-hover:translate-x-2 transition-transform duration-200">
                  <span>Learn more</span>
                  <ArrowRight className="w-4 h-4 ml-2" />
                </div>
              </Link>
            );
          })}
        </div>

        <div className="text-center">
          <Button
            asChild
            size="lg"
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 rounded-xl shadow-lg hover:shadow-xl"
          >
            <Link to="/services" className="flex items-center space-x-2">
              <span>View All Services</span>
              <ArrowRight className="w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesOverview;